// extracted by mini-css-extract-plugin
export default {"button":"plain-date-picker_button__AtJYi","placeHolderShimmer":"plain-date-picker_placeHolderShimmer__O1LoI"};